import script from "./PercentageGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./PercentageGoals.vue?vue&type=script&setup=true&lang=ts"

import "./PercentageGoals.vue?vue&type=style&index=0&id=95e7df64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95e7df64"]])

export default __exports__